import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import config from '../store/_config';
import { buildElasticGraphQLParams } from '../selectors/converterSelector';

export const axiosRequestStoreLocators = (listParams) => {
    let { url, query } = config.stores.listing;
    let params = buildElasticGraphQLParams(listParams);

    query = query.replace(/{params}/, params);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosRequestStoreRegions = () => {
    let { url, query } = config.stores.regionList;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
